import HTTP from '../common/http-common';

const END_POINT = '/brand';

const listBrand = () => HTTP.get(END_POINT);

const insertBrand = (data) => HTTP.post(END_POINT, {
    brandName: data.brandName,
    brandCode: data.brandCode
});
const updateBrand = (data) => HTTP.post(END_POINT + "/" + data.brandId, {
    brandName: data.brandName,
    brandCode: data.brandCode
});

const deleteBrand = (brandId) => HTTP.delete(END_POINT + "/" + brandId);

export {
    listBrand,
    insertBrand,
    updateBrand,
    deleteBrand
}